import { connect } from 'react-redux';

import {
  getAllRates,
  loadPossibleCyclesForUser,
  setFlashcardOnlyMessage,
  setStudySpeedSettings,
  setStudySpeedSettingsMessage,
  setUpdateEmailMessage,
  setUpdatePasswordMessage,
  setUpdatePersonalDataMessage,
  setUpdateProfilePrivacyMessage,
  setUpdateRateMessage,
  setUpdateRatingExamMessage,
  setUpdateRatingExamSuccess,
  setUpdateTimezoneMessage,
  setUpdateUsernameMessage,
  setUploadImageMessage,
  setUploadImageSuccess,
  updateEmail,
  updateFlashcardAction,
  updatePassword,
  updatePersonalData,
  updateProfilePrivacy,
  updateRate,
  updateRatingExam,
  updateTimezone,
  updateUsername,
  uploadProfileImage,
} from '../../actions/accountSettingsAction';
import {
  setUpdateCycleMessage,
  setUserCycle,
} from '../../actions/dashboardActions';
import {
  getAllPublicRates,
  getFlashcardMessage,
  getFlashcardOnly,
  getIsLoadingStudySpeedSettings,
  getPossibleCyclesForUser,
  getStudySpeedSettingsMessage,
  getUpdateEmailMessage,
  getUpdateEmailWaiting,
  getUpdatePasswordMessage,
  getUpdatePasswordWaiting,
  getUpdatePersonalDataMessage,
  getUpdateProfilePrivacyMessage,
  getUpdateProfilePrivacyWaiting,
  getUpdateRateMessage,
  getUpdateRateWaiting,
  getUpdateRatingExamMessage,
  getUpdateRatingExamSuccess,
  getUpdateRatingExamWaiting,
  getUpdateTimezoneMessage,
  getUpdateTimezoneWaiting,
  getUpdateUsernameMessage,
  getUpdateUsernameWaiting,
  getUploadImageMessage,
  getUploadImageSuccess,
  getUploadImageWaiting,
} from '../../components/AccountSettings/AccountSettingsSelectors';
import MyProfile from '../../components/AccountSettings/MyProfile/MyProfileView';
import {
  getDashboardHeaderInfoWaiting,
  getUpdateCycleMessage,
} from '../../components/Dashboard/dashboardSelectors';
import { getUser } from '../../components/User/userSelectors';

const mapStateToProps = (state) => ({
  user: getUser(state),
  possibleCyclesForUser: getPossibleCyclesForUser(state),
  updateUsernameWaiting: getUpdateUsernameWaiting(state),
  updateTimezoneWaiting: getUpdateTimezoneWaiting(state),
  updateProfilePrivacyWaiting: getUpdateProfilePrivacyWaiting(state),
  flashcard: getFlashcardOnly(state),
  flashcardOnlyMessage: getFlashcardMessage(state),
  rates: getAllPublicRates(state),
  uploadImageMessage: getUploadImageMessage(state),
  uploadImageWaiting: getUploadImageWaiting(state),
  uploadImageSuccess: getUploadImageSuccess(state),
  updateUsernameMessage: getUpdateUsernameMessage(state),
  updatePersonalDataMessage: getUpdatePersonalDataMessage(state),
  updateTimezoneMessage: getUpdateTimezoneMessage(state),
  updateProfilePrivacyMessage: getUpdateProfilePrivacyMessage(state),
  updateRateWaiting: getUpdateRateWaiting(state),
  updateRateMessage: getUpdateRateMessage(state),
  updateEmailMessage: getUpdateEmailMessage(state),
  updateEmailWaiting: getUpdateEmailWaiting(state),
  updateRatingExamMessage: getUpdateRatingExamMessage(state),
  updateRatingExamSuccess: getUpdateRatingExamSuccess(state),
  updateRatingExamWaiting: getUpdateRatingExamWaiting(state),
  updatePasswordWaiting: getUpdatePasswordWaiting(state),
  updatePasswordMessage: getUpdatePasswordMessage(state),
  dashboardHeaderInfoWaiting: getDashboardHeaderInfoWaiting(state),
  updateCycleMessage: getUpdateCycleMessage(state),
  studySpeedSettingsMessage: getStudySpeedSettingsMessage(state),
  isLoadingStudySpeedSettings: getIsLoadingStudySpeedSettings(state),
});

const mapDispatchToProps = (dispatch) => ({
  getAllRates: () => dispatch(getAllRates()),
  updateProfilePrivacy: (privacy) => dispatch(updateProfilePrivacy(privacy)),
  updateFlashcardAction: (flashcard) =>
    dispatch(updateFlashcardAction(flashcard)),
  setUpdateProfilePrivacyMessage: (message) =>
    dispatch(setUpdateProfilePrivacyMessage(message)),
  setFlashcardOnlyMessage: (message) =>
    dispatch(setFlashcardOnlyMessage(message)),
  updateTimezone: (timezone) => dispatch(updateTimezone(timezone)),
  setUpdateTimezoneMessage: (message) =>
    dispatch(setUpdateTimezoneMessage(message)),
  updateUsername: (username) => dispatch(updateUsername(username)),
  updatePersonalData: (personalData) =>
    dispatch(updatePersonalData(personalData)),
  setUpdateUsernameMessage: (message) =>
    dispatch(setUpdateUsernameMessage(message)),
  setUpdatePersonalDataMessage: (message) =>
    dispatch(setUpdatePersonalDataMessage(message)),
  updateEmail: (email) => dispatch(updateEmail(email)),
  setUpdateEmailMessage: (message) => dispatch(setUpdateEmailMessage(message)),
  updateRate: (rate) => dispatch(updateRate(rate)),
  setUpdateRateMessage: (message) => dispatch(setUpdateRateMessage(message)),
  updateRatingExam: (id, rate, rank, dutyState, cycleSelected) =>
    dispatch(updateRatingExam(id, rate, rank, dutyState, cycleSelected)),
  setUpdateRatingExamMessage: (message) =>
    dispatch(setUpdateRatingExamMessage(message)),
  setUpdateRatingExamSuccess: (value) =>
    dispatch(setUpdateRatingExamSuccess(value)),
  uploadProfileImage: (imgFile) => dispatch(uploadProfileImage(imgFile)),
  setUploadImageSuccess: (value) => dispatch(setUploadImageSuccess(value)),
  setUploadImageMessage: (message) => dispatch(setUploadImageMessage(message)),
  updatePassword: (oldPassword, newPassword) =>
    dispatch(updatePassword(oldPassword, newPassword)),
  setUpdatePasswordMessage: (message) =>
    dispatch(setUpdatePasswordMessage(message)),
  loadPossibleCyclesForUser: (user) =>
    dispatch(loadPossibleCyclesForUser(user)),
  setUserCycle: (cycleId) => dispatch(setUserCycle(cycleId)),
  setUpdateCycleMessage: (message) => dispatch(setUpdateCycleMessage(message)),
  setStudySpeedSettings: (option) => dispatch(setStudySpeedSettings(option)),
  setStudySpeedSettingsMessage: (message) =>
    dispatch(setStudySpeedSettingsMessage(message)),
});

const MyProfileContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MyProfile);

export default MyProfileContainer;
